let messageSender = null
let isEnabled = false

const init = () => {
  window.addEventListener('message', evt => {
    if (evt.ports.length) {
      messageSender = evt.ports[0]
      isEnabled = true
    }
  })
}

const postMessage = args => {
  if (isEnabled) {
    messageSender.postMessage(JSON.stringify(args))
  }
}

export default {
  init,
  postMessage
}
